import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateMessageRequest,
  DeleteMessageRequest,
  ViewMessageOverviewRequest,
  ViewMessagesRequest
} from './support.types';

import {
  requestCreateMessage,
  requestDeleteMessage,
  requestViewMessageOverview,
  requestViewMessages
} from './support.actions';

export const useSupportApi = () => {
  const dispatch = useDispatch();

  const viewMessageOverview = useCallback(
    (requestData: ViewMessageOverviewRequest, onSuccess?: () => void) => {
      dispatch(requestViewMessageOverview({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewMessages = useCallback(
    (requestData: ViewMessagesRequest, onSuccess?: () => void) => {
      dispatch(requestViewMessages({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const createMessage = useCallback(
    (requestData: CreateMessageRequest, onSuccess?: () => void) => {
      dispatch(requestCreateMessage({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteMessage = useCallback(
    (requestData: DeleteMessageRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteMessage({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { viewMessageOverview, viewMessages, createMessage, deleteMessage };
};
